
import { defineComponent, reactive, computed, ref } from "vue";
import authFooter from "@/modules/auth/components/authFooterComponent.vue"
// import Register from "../../../_models/Register";
import ResponseData from "../../../_models/ResponseData";
import XarcadeAccountService from "../../../services/XarcadeAccountService";
import { useRouter } from 'vue-router';
import { Helper } from "@/utils/Helper";
// form validators
import useValidate from "@vuelidate/core";
import {
  required,
  email,
  minLength,
  maxLength,
  sameAs,
} from "@vuelidate/validators";

export default defineComponent({
  name: "viewAuthSignup",
  components:{
    authFooter
  },
  setup() {
    const router = useRouter();
    const state = reactive({
      userName: "",
      email: "",
      password: {
        password: "",
        // confirmPassword: "",
      },
    });

    const rules = computed(() => {
      return {
        userName: { required },
        email: { required, email },
        password: {
          password: { required, minLength: minLength(8) },
          showConfirmPassword: false,
          // confirmPassword: {
          //   required,
          //   sameAs: sameAs(state.password.password),
          // },
        },
      };
    });

    const activeSection = ref('registerUser');

    const v$ = useValidate(rules, state);

    const submitForm = () => {
      v$.value.$validate();
      if (!v$.value.$error) {
        let registerData = new FormData();
        registerData.append('Email', state.email);
        registerData.append('Username', state.userName);
        registerData.append('Password', state.password.password);
        registerData.append('ConfirmPassword', state.password.password);

        XarcadeAccountService.registerUser(registerData)
          .then((response: ResponseData) => {
            router.push('/signup-success');
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
      } else {
        // console.log("invalid form");
        activeSection.value = "registerUser";
      }
    };

    const disabled = computed(() => {
      return !(state.email.length > 5 && state.userName.length > 5 && state.password.password.length >= 8)
    });

    return {
      state,
      v$,
      submitForm,
      activeSection,
      disabled,
    };
  },

});
